<template>
    <span v-html="markup"></span>
</template>
<script>
import http from 'axios'
export default {
    props: ['src', 'attributes'],
    data() {
        return {
            markup: null,
        }
    },

    mounted() {
        http.get(this.src).then(res => {
            let markup = res.data;
            for(let key in this.attributes) {
                markup = this.insertAttributes(markup, 5, `${key}="${this.attributes[key]}" `);
            }

            this.markup = markup;
        });
    },

    methods: {
        insertAttributes(str, index, value) {
            return str.substr(0, index) + value + str.substr(index);
        }
    }
}
</script>



// WEBPACK FOOTER //
// ../default-js/js/components/util/svgHelper.vue